import React from 'react'

const AlertError = ({title, text, contact = true}) => {

    title = title || "¡Error de comunicación con el servidor!";
    text = text ||  " Por favor recargá la página, si el error persiste ";

    return (
      <div className="alert alert-danger" role="alert" >
        <h4 className="alert-heading">{title}</h4>
        <p style={{marginBottom: 0 + 'px'}}>{text} {contact ? <a href="mailto:migue@fractaldev.org?Subject=Error%20en%20App" className="alert-link">contactá al administrador del sistema.</a> : null }</p>
      </div>
    )
}

export default AlertError



// WEBPACK FOOTER //
// ./src/components/AlertError.js